import { Box, Button, CircularProgress, Typography, useTheme } from '@mui/material';
import { useGetGoalById, useGetGoalNotes, useGetGoalReport } from '_api';
import { DateRangeSelector, GoalNotesDisplay, ReportChart } from 'components/organisms';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { IoMdArrowBack } from 'react-icons/io';

import { ReportViewProps } from './types';

export const GoalReport = ({ id }: ReportViewProps) => {
  const theme = useTheme();
  const { data: goal } = useGetGoalById(id);
  const [showNotes, setShowNotes] = useState(false);
  const [dateRange, setDateRange] = useState<{ startDate: string; endDate: string }>({
    startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    endDate: dayjs().endOf('month').format('YYYY-MM-DD'),
  });
  const {
    data: goalReport,
    isFetching,
    refetch,
  } = useGetGoalReport(id, dateRange.startDate, dateRange.endDate);
  const { data: goalNotes, isFetching: fetchingGoalNotes } = useGetGoalNotes(id);

  useEffect(() => {
    if (!isFetching) refetch();
  }, [dateRange]);

  const handleRangeChange = ({
    startDate,
    endDate,
  }: {
    startDate: string;
    endDate: string;
  }) => {
    setDateRange({ startDate, endDate });
  };

  if (!goalReport && !isFetching) {
    return <Typography variant="h6">Exercise Report Not Found...</Typography>;
  }

  const handleBack = () => {
    history.back();
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', paddingTop: '50px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Box sx={{ marginTop: '10px', color: `${theme.palette.primary.main}` }}>
          <IoMdArrowBack />
        </Box>
        <Button onClick={handleBack} sx={{ justifyContent: 'left' }}>
          {' '}
          Back{' '}
        </Button>
      </Box>
      <Typography variant={'h3'} gutterBottom>
        {goal?.title}
      </Typography>
      <Box>
        <DateRangeSelector onChange={handleRangeChange} onNotesClick={setShowNotes} />
        {!showNotes && goalReport ? (
          <ReportChart
            report={goalReport}
            schedules={[]}
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            hideInfo={true}
            xAxisLabel={'Date'}
          />
        ) : !fetchingGoalNotes && goalNotes ? (
          <GoalNotesDisplay notes={goalNotes} dates={dateRange} />
        ) : (
          <CircularProgress />
        )}
      </Box>
    </Box>
  );
};
